import React from "react";
import { Sparkles, Heart, Leaf, Crown, Droplet, Sun, Zap, Users, FlaskConical } from "lucide-react";

const ServicesSection = () => {
  // Function to handle "Saber Mais" button clicks
  const handleLearnMore = (serviceTitle) => {
    // Scroll to pricing section
    const pricingElement = document.getElementById('precos');
    if (pricingElement) {
      pricingElement.scrollIntoView({ behavior: "smooth" });
      
      // Wait for scroll to complete, then trigger the appropriate category
      setTimeout(() => {
        // Map service titles to pricing category indices
        const categoryMap = {
          "Tratamentos Faciais": 0,
          "Tratamentos Corporais": 1,
          "Massagens Terapêuticas": 2,
          "Cabeleireiro": 3,
          "Depilação Laser Diodo Fibra Ótica": 4,
          "Estética": 5,
          "Packs Noivas": 6,
          "Espaço Cosmetologia": 7
        };
        
        const categoryIndex = categoryMap[serviceTitle];
        if (categoryIndex !== undefined) {
          // Trigger a custom event to open the pricing category
          const event = new CustomEvent('openPricingCategory', { 
            detail: { categoryIndex } 
          });
          window.dispatchEvent(event);
        }
      }, 1000);
    }
  };
  const services = [
    {
      icon: Crown,
      title: "Tratamentos Faciais",
      description: "Revitalize a sua pele com os nossos tratamentos exclusivos",
      features: ["Lux Caviar e Colágeno", "Peeling Ultrasónico", "Microdermabrasão", "Radiofrequência"],
      image: "https://customer-assets.emergentagent.com/job_beauty-rejuvenate/artifacts/c9101clh_facial_treatment.webp",
      color: "bg-gold-warm"
    },
    {
      icon: Droplet,
      title: "Tratamentos Corporais",
      description: "Cuide do seu corpo com terapias relaxantes e rejuvenescedoras",
      features: ["Drenagem Linfática", "Shape Endermologia", "Pressoterapia", "Lipo Laser"],
      image: "https://customer-assets.emergentagent.com/job_beauty-rejuvenate/artifacts/tticruxh_body_treatment.webp",
      color: "bg-aqua-soft"
    },
    {
      icon: Heart,
      title: "Massagens Terapêuticas",
      description: "Relaxe e renove as suas energias com as nossas massagens",
      features: ["Massagem Californiana", "Pedras Quentes", "Massagem Relaxante", "Bambus"],
      image: "https://customer-assets.emergentagent.com/job_beauty-rejuvenate/artifacts/nl0hvqaj_therapeutic_massage.webp",
      color: "bg-sage-soft"
    },
    {
      icon: Zap,
      title: "Depilação Laser Diodo Fibra Ótica",
      description: "Tecnologia avançada para depilação permanente e eficaz",
      features: ["Laser Diodo", "Fibra Ótica", "Tratamento Permanente", "Todas as Áreas Corporais"],
      image: "https://customer-assets.emergentagent.com/job_beauty-rejuvenate/artifacts/6vaf4bq2_laser_hair_removal.webp",
      color: "bg-purple-500"
    },
    {
      icon: Sparkles,
      title: "Estética",
      description: "Tecnologia de ponta para resultados excepcionais",
      features: ["Epilação", "Manicure & Pedicure", "Maquilhagem Flash", "Coloração Pestanas"],
      image: "https://customer-assets.emergentagent.com/job_beauty-rejuvenate/artifacts/o9u0tjnn_opaque_pink_waxing_leg_from_ref.png",
      color: "bg-cream-warm"
    },
    {
      icon: Users,
      title: "Packs Noivas",
      description: "Pacotes especiais para o dia mais importante da sua vida",
      features: ["Tratamentos Faciais", "Maquilhagem Noiva", "Penteados", "Manicure & Pedicure"],
      image: "https://customer-assets.emergentagent.com/job_beauty-rejuvenate/artifacts/5x728rak_bridal_makeup_hairstyle.webp",
      color: "bg-pink-400"
    },
    {
      icon: Leaf,
      title: "SPA Experience",
      description: "Uma experiência completa de bem-estar e relaxamento",
      features: ["Algoterapia", "Vinoterapia", "Chocoterapia", "Candle Massage"],
      image: "https://customer-assets.emergentagent.com/job_beauty-rejuvenate/artifacts/nqyo0ada_chocotherapy.webp",
      color: "bg-gold-soft"
    },
    {
      icon: Sun,
      title: "Cabeleireiro",
      description: "Transforme o seu visual com cortes e tratamentos capilares",
      features: ["Corte & Brushing", "Coloração Orgânica", "Tratamentos Capilares", "Penteados"],
      image: "https://customer-assets.emergentagent.com/job_beauty-rejuvenate/artifacts/636edpef_hair_salon_back_head_loose_hair.webp",
      color: "bg-aqua-warm"
    },
    {
      icon: FlaskConical,
      title: "Espaço Cosmetologia",
      description: "Produtos orgânicos e biológicos para cuidados naturais",
      features: ["Marcas Orgânicas", "Produtos Biológicos", "Cuidados Naturais", "Consultoria Personalizada"],
      image: "https://customer-assets.emergentagent.com/job_beauty-rejuvenate/artifacts/srraehff_organic_cosmetics.webp",
      color: "bg-green-500"
    }
  ];

  return (
    <section id="servicos" className="py-20 bg-cream-light">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-playfair font-bold text-sage-dark mb-6">
            Os Nossos Serviços
          </h2>
          <p className="text-xl text-sage-medium max-w-3xl mx-auto leading-relaxed">
            Descubra uma vasta gama de tratamentos desenhados para realçar a sua beleza natural 
            e proporcionar momentos únicos de bem-estar e relaxamento.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="group bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden transform hover:-translate-y-2">
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className={`absolute top-4 left-4 w-12 h-12 ${service.color} rounded-full flex items-center justify-center`}>
                  <service.icon className="w-6 h-6 text-white" />
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-sage-dark mb-3">{service.title}</h3>
                <p className="text-sage-medium mb-4 leading-relaxed">{service.description}</p>
                
                <ul className="space-y-2 mb-6">
                  {service.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center text-sm text-sage-medium">
                      <div className="w-2 h-2 bg-gold-warm rounded-full mr-3"></div>
                      {feature}
                    </li>
                  ))}
                </ul>
                
                <button 
                  onClick={() => handleLearnMore(service.title)}
                  className="w-full bg-sage-dark text-white py-3 rounded-full hover:bg-gold-warm transition-colors duration-300 font-semibold"
                >
                  Saber Mais
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="mt-16 text-center">
          <div className="bg-white rounded-3xl p-8 shadow-lg max-w-4xl mx-auto">
            <h3 className="text-2xl font-playfair font-bold text-sage-dark mb-4">
              Pronto para a sua transformação?
            </h3>
            <p className="text-sage-medium mb-6 leading-relaxed">
              Entre em contacto connosco e descubra qual o tratamento perfeito para si. 
              A nossa equipa especializada ajuda-o a escolher a melhor opção.
            </p>
            <button 
              onClick={() => {
                const element = document.getElementById('contacto');
                if (element) element.scrollIntoView({ behavior: "smooth" });
              }}
              className="bg-gold-warm text-white px-8 py-4 rounded-full hover:bg-gold-deep transition-all duration-300 transform hover:scale-105 font-semibold"
            >
              Contactar
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;